// Recipe-archive search bar — UX glue for the clear-state.
//
//  • Submitting the form with an empty input drops the `recipe_search`
//    query param entirely (instead of leaving `?recipe_search=` in the
//    URL).
//  • Toggle the inline ✕ clear button as the user types / deletes.
//  • Pressing Escape clears the field and re-navigates to the bare
//    archive URL — keyboard parity with the visible ✕ button.

(() => {
    const form = document.querySelector('[data-recipe-search]');
    if (!form) return;

    const input = form.querySelector('[data-recipe-search-input]');
    const clear = form.querySelector('[data-recipe-search-clear]');
    if (!input) return;

    const archiveUrl = form.getAttribute('action') || window.location.pathname;

    const toggleClear = () => {
        if (!clear) return;
        clear.classList.toggle('is-hidden', input.value.trim() === '');
    };

    input.addEventListener('input', toggleClear);

    // Esc anywhere inside the search → clear and reload the bare URL.
    input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value !== '') {
            event.preventDefault();
            window.location.assign(archiveUrl);
        }
    });

    // If the user submits with an empty field, send them to the bare URL
    // instead of `?recipe_search=` — keeps the address bar tidy and lets
    // the server-side branch fall back to the main archive query.
    form.addEventListener('submit', (event) => {
        if (input.value.trim() === '') {
            event.preventDefault();
            window.location.assign(archiveUrl);
        }
    });

    toggleClear();
})();
